import React, { useState, useEffect, useRef } from "react";
import { Navbar } from "../../../components/ClientPage";
import { Footer } from "../../../container/ClientPage";
import { useTranslation } from "react-i18next";
import "./MenuPage.css";

const MenuPage = () => {
  const { t } = useTranslation();
  const totalPages = 48;
  const [visiblePages, setVisiblePages] = useState(3);
  const observerRef = useRef(null);

  // Tạo danh sách ảnh
  const images = Array.from({ length: totalPages }, (_, i) => `/assets/menu/menu_page_${i + 1}.webp`);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // Khi user kéo gần cuối, load thêm ảnh
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const lastEntry = entries[0];
        if (lastEntry.isIntersecting && visiblePages < totalPages) {
          setVisiblePages((prev) => Math.min(prev + 3, totalPages));
        }
      },
      { threshold: 0.1 }
    );
    if (observerRef.current) observer.observe(observerRef.current);
    return () => observer.disconnect();
  }, [visiblePages, totalPages]);

  return (
    <div className="app__menuPage">
      <Navbar />

      <div className="app__menuPage-header">
        <div className="app__menuPage-title">
          <h1 className="headtext__cormorant">{t("menu_page.title")}</h1>
        </div>
      </div>

      <div className="app__menuPage-content">
        <div className="app__menuPage-imageContainer">
          {images.slice(0, visiblePages).map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Menu Page ${index + 1}`}
              className="menu__image"
              loading="lazy"
            />
          ))}

          {visiblePages < totalPages && <div ref={observerRef} className="load-trigger" />}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MenuPage;
